import HeroDivider from "/app/src/components/HeroUi/Divider";
import { useTranslation } from "react-i18next";
import PowerPickTimeZone from "./powerPickTimeZone";
import TimeZone from "./timeZone";
import DefaultWarehouse from "./warehouse";
import License from "./license";
import Url from "./url";
import DefaultMaterialProperty from "./materialProperty";
import Box from "/app/src/components/generic/components/box";

/**
 * Component to display the forms for updating the license, url, time zone, and default warehouse
 */
export default function General() {
  const { t } = useTranslation();
  return (
    <Box>
      <h1>{t("translation:general_settings")}</h1>
      <HeroDivider className="my-6" />
      <Url />
      <HeroDivider className="my-6" />
      <License />
      <HeroDivider className="my-6" />
      <TimeZone />
      <HeroDivider className="my-6" />
      <PowerPickTimeZone />
      <HeroDivider className="my-6" />
      <DefaultWarehouse />
      <HeroDivider className="my-6" />
      <DefaultMaterialProperty />
    </Box>
  );
}
